import { render, staticRenderFns } from "./CommonStoreList.vue?vue&type=template&id=f67437d4&scoped=true&"
import script from "./CommonStoreList.vue?vue&type=script&lang=js&"
export * from "./CommonStoreList.vue?vue&type=script&lang=js&"
import style0 from "./CommonStoreList.vue?vue&type=style&index=0&id=f67437d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67437d4",
  null
  
)

export default component.exports